
<template>
  <div>
    <div class="row">
      <div class="col" style="margin-bottom:15px;text-align:center;">
        <div style="border: 2px solid;color:#00467f;margin-left:60px;margin-right:60px">
          <h4 class="card-title" style="color:#00467f;margin-top:10px"><strong>LEGENDA</strong></h4>
          <div class="row">
              <div class="col" style="text-align:center;margin-left:100px;margin-bottom:5px"><button v-on:click="filterByStatus('green')" type="button" style="border: none;background:#f5f6fa"><img src="@/assets/img/green.png" style="width:20px;margin-right:15px;margin-bottom:5px"><i style="text-decoration:underline;">COMPLETATO</i></button></div>
              <div class="col" style="text-align:center;margin-left:10px;margin-bottom:5px"><button v-on:click="filterByStatus('yellow')" type="button" style="border: none;background:#f5f6fa"><img src="@/assets/img/yellow.png" style="width:20px;margin-right:15px;margin-bottom:5px"><i style="text-decoration:underline;">COMPILA</i></button></div>
              <div class="col" style="text-align:center;margin-left:10px;margin-bottom:5px"><button v-on:click="filterByStatus('blue')" type="button" style="border: none;background:#f5f6fa"><img src="@/assets/img/blue.png" style="width:20px;margin-right:15px;margin-bottom:5px"><i style="text-decoration:underline;">ATTENDI</i></button></div>
              <div class="col" style="text-align:center;margin-left:10px;margin-right:100px;margin-bottom:5px"><button v-on:click="filterByStatus('red')" type="button" style="border: none;background:#f5f6fa"><img src="@/assets/img/red.png" style="width:20px;margin-right:15px;margin-bottom:5px"><i style="text-decoration:underline;">FALLITO</i></button></div>
          </div>
        </div>
      </div>
      <!--<div class="col"><span class="float-right">
        <div class="search-bar input-group"  @click="searchModalVisible = true">
          <button class="btn btn-link" id="search-button" data-toggle="modal" data-target="#searchModal"><i class="tim-icons icon-zoom-split"></i>
            <span class="d-lg-none d-md-block">Search</span>
          </button>
        </div>
        <modal :show.sync="searchModalVisible"
                class="modal-search"
                id="searchModal"
                :centered="false"
                :show-close="true">
          <input type="text" id="ricerca" class="form-control" v-on:keyup="cerca()" name="ricerca" placeholder=" Cerca...">
        </modal>
        </span>
      </div>-->
    </div>
    <div class="row d-flex justify-content-start">
        <!--
        <label class="switch" style="margin-left:15px">
        <input type="checkbox" checked>
        <span class="slider round"></span>
        </label>
        -->
        <div>
          Ricerca per:
            <input type="radio" id="nome_azienda" value="nome_azienda" v-model="filtra_per" style="margin-left:40px">
            <label for="nome_azienda" style="margin-left:5px;margin-right:10px;font-size:15px">nome azienda</label>
             <input type="radio" id="codice_fiscale" value="codice_fiscale" v-model="filtra_per" style="margin-left:40px">
            <label for="codice_fiscale" style="margin-left:5px;margin-right:10px;font-size:15px">codice fiscale</label>
        </div>
    </div>
    <div class="row" style="margin-top:25px">
      <div class="col" style="text-align:left; margin-bottom:15px">
          <input type="text" id="ricerca" v-on:keyup="cercaPratica()" name="ricerca" placeholder=" Cerca..."> 
      </div>
    </div>
    <div class="row">
      <div class="col">
        <card class="card">
          <div class="table-responsive">
            <table class="table tablesorter" id="tabella" style="text-align: center">
              <thead>
                <tr>
                  <th>DATA</th>
                  <th>AZIENDA</th>
                  <th>CODICE FISCALE</th>
                  <th>REFERENTE AZIENDA</th>
                  <th>TEL</th>
                  <th>MAIL</th>
                  <th>SEDE DOVE EFFETTUARE IL SOPRALLUOGO</th>
                  <th>TIPO RICHIESTA</th>
                  <th>AVANZAMENTO</th>
                  <th>STATO</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(valori, index) in valori" v-bind:key="valori.ID">
                  <td>{{getDate(valori.DATA_INSERIMENTO)}}</td>
                  <td>{{valori.AZIENDA}}</td>
                  <td>{{valori.CODICE_FISCALE}}</td>
                  <td>{{valori.REFERENTE_AZIENDA}}</td>
                  <td>{{valori.TEL}}</td>
                  <td>{{valori.MAIL}}</td>
                  <td>{{valori.SEDE}}</td>
                  <td>{{valori.TIPO}}</td>
                  <td>{{valori.AVANZAMENTO}}</td>
                  <td><img :src="img_check[index]" style="width:20px"></td>
                  <td v-if="(valori.AVANZAMENTO == 1 && (user_livello==1) ) 
                      || (valori.AVANZAMENTO==2 && (user_livello==1 || user_livello==4 || user_livello==5)) 
                      || (valori.AVANZAMENTO==3 && (user_livello==1 || user_livello == 4))
                      || (valori.AVANZAMENTO==4 && (user_livello==1 || user_livello==2 || user_livello==3)) 
                      || (valori.AVANZAMENTO==5 && (user_livello==1 || user_livello == 2))
                      || (valori.AVANZAMENTO==6 && (user_livello==1 || user_livello==4 || user_livello==5))
                      || (valori.AVANZAMENTO==7 && (user_livello==1 || user_livello == 2))
                      || (valori.AVANZAMENTO==8 && (user_livello==1 || user_livello==4 || user_livello==5))">
                      <!-- || (valori.AVANZAMENTO==9 && (user_livello==1 || user_livello==2 || user_livello==3 || user_livello==4 || user_livello==5))-->
                    <router-link :to="'/modifica-dati?id='+valori.ID"><i class="tim-icons icon-pencil" style="color:#00467f"></i></router-link>
                  </td>
                  <td v-else-if="valori.AVANZAMENTO == 9"><router-link :to="'/modifica-dati?id='+valori.ID"><i class="tim-icons icon-zoom-split" style="color:#00467f"></i></router-link></td>
                  <td v-else></td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'

import Card from "../components/Cards/Card.vue";
import Modal from "@/components/Modal.vue";
import Legenda from "@/components/Legenda.vue";


export default {
  components: {
    Card,
    Modal,
    Legenda
  },

  data() {
    return {
      searchModalVisible: false,
      searchQuery: '',
      page: 1,
      totPage: null,
      
      img_check: [],
      avanzamento: null,
      status: null,
      token_repsonse: '',
      valori: [],
      allPratiche: [],
      yellow_array: [],
      img_yellow: [],
      blue_array: [],
      img_blue: [],
      green_array: [],
      img_green: [],
      red_array: [],
      img_red: [],
      results: [],
      //avanzamento_selected: null,
      filtra_per: 'nome_azienda',
      user_livello: '',
      urlRichieste: 'https://sviluppoallergeni.confcom.it/',//'https://apiintranet.confcom.it/',
      header:{
        headers: {
            'Content-type': 'application/json',
        }
      },
    };
  },

  methods: {
    cercaPratica: function() {
      let input, txtValue, i, filter;
      input = document.getElementById("ricerca");
      let arrayFiltrato = [];
      if( this.filtra_per == 'nome_azienda'){
        filter = input.value.toUpperCase();
        for( i = 0; i < this.allPratiche.length; i++){
          txtValue = this.allPratiche[i].AZIENDA;
          if( txtValue.toUpperCase().indexOf(filter) > -1 ){
            arrayFiltrato.push(this.allPratiche[i]);
          }
        }
      } else {
        // filtra_per == 'codice_fiscale'
        filter = input.value;
        for( i = 0; i < this.allPratiche.length; i++){
          txtValue = this.allPratiche[i].CODICE_FISCALE;
          if( txtValue.toUpperCase().indexOf(filter) > -1 ){
            arrayFiltrato.push(this.allPratiche[i]);
          }
        }
      }
      this.valori = arrayFiltrato;
      if(filter == ''){
        this.caricaPagina();
      }
    },

    filtraAvanzamento: async function(){
      const token = localStorage.getItem('access_token');
      this.img_check = [];
      let errore = 0;
      if(this.avanzamento_selected == "tutti"){
        this.caricaPagina();
      } else {
        await axios.get(
          this.urlRichieste + "pratica?filter=true&AVANZAMENTO=" + this.avanzamento_selected,
          //"https://sviluppoallergeni.confcom.it/pratica?filter=true&AVANZAMENTO=" + this.avanzamento_selected,
          {
            withCredentials: true,
            headers: {
              'Content-type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          }
        ).then(response => { this.valori = response.data})
        .catch(function (error) {
          // handle error
          console.log("errore : ");
          console.log(error);
          console.log("error.status " + error.response.status);
          if(error.response.status == 401){
            errore = error.response.status;
          }
        })
        if (errore == 401) {
          let value = await this.refreshToken();
          if (value) { await this.filtraAvanzamento(); }
        }
        //console.log("filtra per avanzamento = " + this.avanzamento_selected)
        //console.log(this.valori)
      }
      for( var i = 0; i < this.valori.length; i++){
        if(this.valori[i].CHECK_1 == false || this.valori[i].CHECK_2 == false || this.valori[i].CHECK_3 == false || this.valori[i].CHECK_4 == false){
          this.img_check.push(require('@/assets/img/red.png'));
        } else {
          this.caricaPalliniPagina(i);
        }
      }
    },

    filtraMie: async function() {
      const token = localStorage.getItem('access_token');
      this.img_check = [];
      let user_id = localStorage.getItem('user_id');
      let errore = 0;
      await axios.get(
        this.urlRichieste + "pratica?filter=true&CREATA_DA=" + user_id,
        //"https://sviluppoallergeni.confcom.it/pratica?filter=true&CREATA_DA=" + user_id,
          {
            withCredentials: true,
            headers: {
              'Content-type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          }
        ).then(response => { this.valori = response.data})
        .catch(function (error) {
          // handle error
          if(error.response.status == 401){
            errore = error.response.status;
          }
        })
        if (errore == 401) {
          let value = await this.refreshToken();
          if (value) { await this.filtraMie(); }
        }
        //console.log("filtra per user_id = " + user_id);
        //console.log(this.valori);
      
      for( var i = 0; i < this.valori.length; i++){
          if(this.valori[i].CHECK_1 == false || this.valori[i].CHECK_2 == false || this.valori[i].CHECK_3 == false || this.valori[i].CHECK_4 == false){
            this.img_check.push(require('@/assets/img/red.png'));
          } else {
            this.caricaPalliniPagina(i);
          }
        }
    },

    refreshToken: async function(){ 
      let errore = 0;
      await axios.post(
        this.urlRichieste + "token",
        //"https://sviluppoallergeni.confcom.it/token",
        {
          withCredentials: true,
          headers: {
            'Content-type': 'application/json',
          }
        }
      ).then(response => { this.token_repsonse = response.data})
      .catch(function (error) {
        // handle error
        if(error.response.status == 403 || error.response.status == 401){
          errore = error.response.status;
        }
      })
      if (errore == 403 || errore == 401) {
        await this.logout();
        return false;
      }
      localStorage.setItem('access_token', this.token_repsonse);
      return true;
    },

    //OK
    caricaPallino: function(i){
      if(this.allPratiche[i].CHECK_1 == false || this.allPratiche[i].CHECK_2 == false || this.allPratiche[i].CHECK_3 == false || this.allPratiche[i].CHECK_4 == false){
        this.red_array.push(this.allPratiche[i]);
        this.img_red.push(require('@/assets/img/red.png'));
      }
      else if( this.allPratiche[i].AVANZAMENTO == 1){
        //se ASCOM GIALLO
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
        }
        //Se SATEC BLU
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 2){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
        }
        //Se SATEC GIALLO
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          this.yellow_array.push(this.allPratiche[i]);
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 3){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
        }
        //Se SATEC BLU
        else if( localStorage.getItem('user_livello') ==  4 ){
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 4){
        //se ASCOM GIALLO
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
        }
        //Se SATEC BLU
        else if( localStorage.getItem('user_livello') ==  4|| localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 5){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2){
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
        }
        //Se SATEC blue
        else if( localStorage.getItem( localStorage.getItem('user_livello') == 3 || 'user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 6){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
        }
        //Se SATEC GIALLO
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          this.yellow_array.push(this.allPratiche[i]);
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          this.yellow_array.push(this.allPratiche[i]);
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 7){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 ){
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.img_blue.push(require('@/assets/img/blue.png'));
          this.blue_array.push(this.allPratiche[i]);
        }
        //Se SATEC BLUE
        else if( localStorage.getItem(localStorage.getItem('user_livello') == 3 || 'user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          this.yellow_array.push(this.allPratiche[i]);
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 8){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          //this.img_check.push(require('@/assets/img/blue.png'))
          this.blue_array.push(this.allPratiche[i]);
          this.img_blue.push(require('@/assets/img/blue.png'));
        }
        //Se SATEC GIALLO
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.img_yellow.push(require('@/assets/img/yellow.png'));
          this.yellow_array.push(this.allPratiche[i]);
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/yellow.png'))
          this.yellow_array.push(this.allPratiche[i]);
          this.img_yellow.push(require('@/assets/img/yellow.png'));
        }
      }
      else if( this.allPratiche[i].AVANZAMENTO == 9){
        //se ASCOM VERDE
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          //this.img_check.push(require('@/assets/img/green.png'))
          this.green_array.push(this.allPratiche[i]);
          this.img_green.push(require('@/assets/img/green.png'));
        }
        //Se SATEC VERDE
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          //this.img_check.push(require('@/assets/img/green.png'))
          this.green_array.push(this.allPratiche[i]);
          this.img_green.push(require('@/assets/img/green.png'));
        } else{
          //ADMIN 1 
          //this.img_check.push(require('@/assets/img/green.png'))
          this.green_array.push(this.allPratiche[i]);
          this.img_green.push(require('@/assets/img/green.png'));
        }
      } else{
        console.log("...");
        this.red_array.push(this.allPratiche[i]);
        this.img_red.push(require('@/assets/img/red.png'));
      }
    },

    //
    caricaPalliniPagina: function(i){
      if(this.valori[i].CHECK_1 == false || this.valori[i].CHECK_2 == false || this.valori[i].CHECK_3 == false || this.valori[i].CHECK_4 == false){
        this.img_check.push(require('@/assets/img/red.png'));
      }
      else if( this.valori[i].AVANZAMENTO == 1){
        //se ASCOM GIALLO
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          this.img_check.push(require('@/assets/img/blue.png'));
        }
        //Se SATEC BLU
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/blue.png'));
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/yellow.png'));
        }
      }
      else if( this.valori[i].AVANZAMENTO == 2){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          this.img_check.push(require('@/assets/img/blue.png'));
        }
        //Se SATEC GIALLO
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/yellow.png'));
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/yellow.png'));
        }
      }
      else if( this.valori[i].AVANZAMENTO == 3){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/blue.png'));
        }
        //Se SATEC BLU
        else if( localStorage.getItem('user_livello') ==  4 ){
          this.img_check.push(require('@/assets/img/yellow.png'));
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/yellow.png'));
        }
      }
      else if( this.valori[i].AVANZAMENTO == 4){
        //se ASCOM GIALLO
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          this.img_check.push(require('@/assets/img/yellow.png'));
        }
        //Se SATEC BLU
        else if( localStorage.getItem('user_livello') ==  4|| localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/blue.png'));
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/yellow.png'));
        }
      }
      else if( this.valori[i].AVANZAMENTO == 5){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2){
          this.img_check.push(require('@/assets/img/yellow.png'));
        }
        //Se SATEC blue
        else if( localStorage.getItem( localStorage.getItem('user_livello') == 3 || 'user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/blue.png'));
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/blue.png'));
        }
      }
      else if( this.valori[i].AVANZAMENTO == 6){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          this.img_check.push(require('@/assets/img/blue.png'));
        }
        //Se SATEC GIALLO
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/yellow.png'));
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/yellow.png'));
        }
      }
      else if( this.valori[i].AVANZAMENTO == 7){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 ){
          this.img_check.push(require('@/assets/img/yellow.png'));
        }
        //Se SATEC BLUE
        else if( localStorage.getItem(localStorage.getItem('user_livello') == 3 || 'user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/blue.png'));
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/yellow.png'));
        }
      }
      else if( this.valori[i].AVANZAMENTO == 8){
        //se ASCOM BLU
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          this.img_check.push(require('@/assets/img/blue.png'));
        }
        //Se SATEC GIALLO
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/yellow.png'));
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/yellow.png'));
        }
      }
      else if( this.valori[i].AVANZAMENTO == 9){
        //se ASCOM VERDE
        if( localStorage.getItem('user_livello') == 2 || localStorage.getItem('user_livello') == 3){
          this.img_check.push(require('@/assets/img/green.png'));
        }
        //Se SATEC VERDE
        else if( localStorage.getItem('user_livello') ==  4 || localStorage.getItem('user_livello') == 5){
          this.img_check.push(require('@/assets/img/green.png'));
        } else{
          //ADMIN 1 
          this.img_check.push(require('@/assets/img/green.png'));
        }
      } else{
        console.log("stato avanzamento sbalgiato");
        this.img_check.push(require('@/assets/img/red.png'));
      }
    },


    //OK
    filterByStatus: function(value) {
      if( value == 'yellow'){
        this.valori = this.yellow_array;
        this.img_check = this.img_yellow;
        return this.valori;
      }
      else if( value == 'green'){
        this.valori = this.green_array;
        this.img_check = this.img_green;
        return this.valori;
      }
      else if( value == 'blue'){
        this.valori = this.blue_array;
        this.img_check = this.img_blue;
        return this.valori;
      } else {
        this.valori = this.red_array;
        this.img_check = this.img_red;
        return this.valori;
      }
    },

    changePage: async function(val){
      let risposta;
      let errore = 0;
      if(val == 'avanti'){
        this.page = this.page + 1;
      } else {
        //indietro
        this.page = this.page - 1;
      }
      this.img_check = [];
       const token = localStorage.getItem('access_token');
        await axios.get(
          this.urlRichieste + 'pratica?page='+this.page+'&limit=10',
          //'https://sviluppoallergeni.confcom.it/pratica?page='+this.page+'&limit=10', 
          {headers: {
              'Content-type': 'application/json',
              'Authorization': `Bearer ${token}`
          }}
        ).then(response => { risposta = response.data})
        .catch( async function (error) {
          // handle error
          if(error.response.status == 401){
            errore = error.response.status;
          }
        })
        if (errore == 401) {
          let value = await this.refreshToken();
          if (value) { await this.changePage(); }
        }
        this.valori = risposta.rows;
        console.log("stampa valori");
        console.log(this.valori);
      
        for( let i = 0; i < this.valori.length; i++){
          if(this.valori[i].CHECK_1 == false || this.valori[i].CHECK_2 == false || this.valori[i].CHECK_3 == false || this.valori[i].CHECK_4 == false){
            this.img_check.push(require('@/assets/img/red.png'));
          } else {
            this.caricaPalliniPagina(i);
          }
        }
    },

    caricaPagina: async function(){
      const token = localStorage.getItem('access_token');
      let risposta;
      let errore = 0;
      this.img_check = [];
      await axios.get(
        this.urlRichieste + 'pratica?page=1&limit=10',
        //'https://sviluppoallergeni.confcom.it/pratica?page=1&limit=10', 
        {headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }}
      ).then(response => { risposta = response.data})
       .catch( async function (error) {
        // handle error
        if(error.response.status == 401){
          errore = error.response.status;
        }
      })
      if (errore == 401) {
        let value = await this.refreshToken();
        if (value) { await this.caricaPagina(); }
      }
      console.log("stampa pagina");
      console.log(risposta);
      this.valori = risposta.rows;
      // Faciamo che ne mostro 10 per pagina
      let total = this.allPratiche.length;
      this.totPage = Math.ceil(total/10);
      console.log("pagina = " + this.page + ", totPage = " + this.totPage);
      for( var i = 0; i < this.valori.length; i++){
        if(this.valori[i].CHECK_1 == false || this.valori[i].CHECK_2 == false || this.valori[i].CHECK_3 == false || this.valori[i].CHECK_4 == false || this.valori[i].AVANZAMENTO > 9){
          this.img_check.push(require('@/assets/img/red.png'));
        } else {
          this.caricaPalliniPagina(i);
        }
      }
    },

    getAllPratiche: async function(){
      const token = localStorage.getItem('access_token');
      let errore = 0;
      await axios.get(
        this.urlRichieste + 'pratica',
        //'https://sviluppoallergeni.confcom.it/pratica', 
        {headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }}
      ).then(response => { this.allPratiche = response.data})
       .catch( async function (error) {
        // handle error
        if(error.response.status == 401){
          errore = error.response.status;
        }
      })
      if (errore == 401) {
        let value = await this.refreshToken();
        if (value) { await this.caricaPratiche(); }
      }
      console.log("numero tot pratiche " + this.allPratiche.length);
      for(var i = 0; i < this.allPratiche.length; i++){
        this.caricaPallino(i);
      }
    },

    logout: async function () {
      //let ris = await logout.UserServices()
      let token = localStorage.getItem('access_token');
      await axios.delete(
        this.urlRichieste + 'logout',
        //'https://sviluppoallergeni.confcom.it/logout',
          {
          withCredentials: true,
          headers: {
            'Content-type': 'application/json',
            //'Authorization': `Bearer ${token}`
          }
        }
      ).then(response => { this.results = response.data})
      console.log("stampo risposta /logout:");
      console.log(this.results);
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.setItem('isLogged', false);
      localStorage.removeItem('user_nome');
      localStorage.removeItem('user_cognome');
      localStorage.removeItem('user_tipologia');
      localStorage.removeItem('user_email');
      localStorage.removeItem('user_livello');
      localStorage.removeItem('user_id');
      this.$router.push({
        path: '/login'
      })
    },

    main: async function() {
      axios.defaults.withCredentials = true;
      this.user_livello = localStorage.getItem('user_livello');
      try {
        await this.getAllPratiche();
        await this.caricaPagina();
      } catch (error) {
        if (error.response.status == 401) {
          await this.refreshToken();
        }
      }
    },

    getDate(datetime) {
      return moment(String(datetime)).format('DD/MM/YYYY');
    }
  },

  mounted() {
    this.main();
  },
};
</script>
<style scoped>
  .arrow {
    border: solid #00467f;
    border-width: 0 3px 3px 0;
    background: white;
    display: inline-block;
    padding: 7px;
  }

  .right {
    transform: rotate(-45deg);
  }

  .left {
    transform: rotate(135deg);
  }

  @media screen and (max-width: 500px) {
    .hidemobile {
      display: none;
    }
  }
  @media screen and (min-width: 500px) {
    .hidecomputer {
      display:  none;
    }
  }

  body {
    font-family: Roboto, sans-serif;
  }
  button, input, optgroup, select, textarea {
    font-family: Roboto, sans-serif;
  }

  .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #00467f;
}

input:focus + .slider {
  box-shadow: 0 0 1px #00467f;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

</style>
